import Vue from 'vue';
import debounce from "debounce";

import { IPage, IState } from '@/store/state';

export interface PageListNavigatorMethods {
	tabFocus(): void;
}

interface PageListNavigatorMethodsInternal extends PageListNavigatorMethods {
	pageFocused(pageId: string | null): void;
	shouldFocus(page: IPage): void;
	shouldFocusContent(page: IPage): void;
	moveFocus(e: KeyboardEvent): void;
	setFocus(up: boolean): void;
}

interface PageListNavigatorData {
	currentFocusPageId: string | null;
	tabPressed: boolean;
}

export interface PageListNavigatorComputed {
	pages: IPage[];
}

export default Vue.extend<
	PageListNavigatorData,
	PageListNavigatorMethodsInternal,
	PageListNavigatorComputed,
	{}
>({
	created(){
		document.addEventListener("keyup", debounce(this.moveFocus.bind(this), 50));
	},
	data() {
		return {
			currentFocusPageId: null,
			tabPressed: false
		};
	},
	methods: {
		tabFocus() {},
		pageFocused(pageId) {
			this.currentFocusPageId = pageId;
		},
		moveFocus(e) {
			const key = e.which || e.keyCode;

			switch (key) {
				case 38: // Up arrow
					this.setFocus(true);
					break;
				case 40: // Down arrow
					this.setFocus(false);
					break;
				case 9:
					this.tabPressed = true;
					break;
				default:
					this.tabPressed = false;
					break;
			}
		},
		setFocus(up) {
			if (this.currentFocusPageId) {
				let currentFocusPageIndex = this.pages.findIndex(
					page => page.id === this.currentFocusPageId
				);
				currentFocusPageIndex = up
					? currentFocusPageIndex - 1
					: currentFocusPageIndex + 1;
				if (currentFocusPageIndex < 0) {
					currentFocusPageIndex = this.pages.length - 1;
				} else if (currentFocusPageIndex > this.pages.length - 1) {
					currentFocusPageIndex = 0;
				}
				this.currentFocusPageId = this.pages[currentFocusPageIndex].id;
			}
		},
		shouldFocus(page) {
			return page.id === this.currentFocusPageId;
		},
		shouldFocusContent(page) {
			if(this.tabPressed) {
				return this.shouldFocus(page);
			}
		}
	}
});
